import moment from 'moment';

export function reshapeSnapshot(data) {
  // const avgVisitIndex = getAverage(data['dimVisitIndex']);
  const reshaped = [];
  let keys = Object.keys(data);
  let length = keys.length > 0 ? data[keys[0]].length : 0;
  for (let i = 0; i < length; i++) {
    const obj = {};
    for (let k = 0; k < keys.length; k++) {
      let key;
      key = keys[k];
      obj[key] = data[key][i];
    }
    // obj['fracIndex'] = Number.parseFloat(data['dimVisitIndex'][i] / avgVisitIndex * 100).toFixed(3);
    reshaped.push(obj);
  }
  return reshaped;
}

export function calcFractionalIndex(dimVisit, avgVisitIndex) {
  const fracIndex = (dimVisit / avgVisitIndex) * 100;
  return Number.parseFloat(fracIndex).toFixed(3);
}

export function transpose(matrix) {
  return matrix[0].map((col, i) => matrix.map((row) => row[i]));
}

export function isNonZeroElement(array) {
  return Array.isArray(array) ? array.some((ar) => ar > 0) : false;
}

export function getUniqueByKey(array, key) {
  if (!array || !key) {
    return [];
  }
  const uniques = [];
  array.forEach((ar) => {
    if (!uniques.includes(ar[key])) {
      uniques.push(ar[key]);
    }
  });

  return uniques;
}

export function percentNormalization(data) {
  const maxValue = data[0]['percentage'];

  return data.map((d) => ({
    ...d,
    percentage: (d['percentage'] * 100) / maxValue, // Normalize 'percentage'
  }));
}

export function bucketDwellTime(data) {
  const dwellTime = [0, 0, 0, 0, 0, 0, 0];
  Object.keys(data).forEach((prop) => {
    const d = parseInt(prop, 10);
    let idx = -1;
    if (d >= 0 && d <= 10) {
      idx = 0;
    }
    if (d >= 11 && d <= 20) {
      idx = 1;
    }
    if (d >= 21 && d <= 30) {
      idx = 2;
    }
    if (d >= 31 && d <= 40) {
      idx = 3;
    }
    if (d >= 41 && d <= 50) {
      idx = 4;
    }
    if (d >= 51 && d <= 60) {
      idx = 5;
    }
    if (d >= 61) {
      idx = 6;
    }
    if (idx !== -1) {
      let count = dwellTime[idx];
      count += data[prop];
      dwellTime[idx] = count;
    }
  });
  return dwellTime;
}

export function bucketDistanceData(data) {
  const distanceData = [0, 0, 0, 0, 0];
  Object.keys(data).forEach((prop) => {
    const d = parseInt(prop, 10);
    let idx = -1;
    if (d >= 0 && d <= 2) {
      idx = 0;
    }
    if (d > 2 && d <= 5) {
      idx = 1;
    }
    if (d > 5 && d <= 10) {
      idx = 2;
    }
    if (d > 10 && d <= 15) {
      idx = 3;
    }
    if (d > 15) {
      idx = 4;
    }
    if (idx !== -1) {
      let count = distanceData[idx];
      count += data[prop];
      distanceData[idx] = count;
    }
  });
  return distanceData;
}

export function bucketDistanceDatainMiles(data) {
  const distanceData = [0, 0, 0, 0, 0];
  Object.keys(data).forEach((prop) => {
    const d = parseInt(prop, 10);
    let idx = -1;
    if (d >= 0 && d <= 1) {
      idx = 0;
    }
    if (d > 1 && d <= 3) {
      idx = 1;
    }
    if (d > 3 && d <= 6) {
      idx = 2;
    }
    if (d > 6 && d <= 9) {
      idx = 3;
    }
    if (d > 9) {
      idx = 4;
    }
    if (idx !== -1) {
      let count = distanceData[idx];
      count += data[prop];
      distanceData[idx] = count;
    }
  });
  return distanceData;
}

export function getPercentileData(data, sum, percentile) {
  const quartile =
    percentile === '1st Quartile'
      ? 25
      : percentile === 'Median'
        ? 50
        : percentile === '3rd Quartile'
          ? 75
          : 100;
  if (quartile === 100) {
    return data;
  } else {
    let total = 0;
    const filteredData = [];
    for (let i = 0; i < data.length; i++) {
      total = total + data[i]['dimImpressions'];
      filteredData.push(data[i]);
      if (total >= (sum * quartile) / 100) {
        break;
      }
    }

    return filteredData;
  }
}

// const getAverage = visitIndexes => visitIndexes.reduce((a, b) => a + b, 0) / visitIndexes.length;

export const channelMap = {
  inapp: 'App',
  dweb: 'Desktop',
  mweb: 'Mobile Web',
  social: 'Social',
  search: 'Search',
  email: 'Email',
  lf: 'Lead Form',
  ooh: 'Billboard',
  lp: 'Landing Page',
  webrooming: 'Webrooming',
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'Youtube',
  twitter: 'Twitter',
  yahoo: 'Yahoo',
  gads: 'Google Ads',
  gmp: 'Google MP',
  gadsmanager: 'Google Ad Manager',
  aac: 'Adobe Advertising Cloud',
  mediamath: 'Mediamath',
  inmobi: 'Inmobi',
  customdsp: 'Custom DSP',
  'custom dsp1': 'Custom DSP 1',
  'custom dsp2': 'Custom DSP 2',
  'custom dsp3': 'Custom DSP 3',
  'custom dsp4': 'Custom DSP 4',
  'custom dsp5': 'Custom DSP 5',
  'custom dsp6': 'Custom DSP 6',
  'custom dsp7': 'Custom DSP 7',
  'custom dsp8': 'Custom DSP 8',
  'custom dsp9': 'Custom DSP 9',
  'custom dsp10': 'Custom DSP 10',
  affmarketing: 'Affiliate Marketing',
  amobee: 'Amobee',
  adcolony: 'Ad Colony',
  dataxu: 'DataXu',
  ott: 'OTT',
  ttd: 'The Trade Desk',
  appnexus: 'AppNexus',
  adform: 'AdForm',
  quantcast: 'Quantcast',
  verizonmedia: 'Verizon Media',
  spotad: 'SpotAd',
  affle: 'Affle',
  kargo: 'Kargo',
  unknown: 'Unknown',
  dooh: 'DOOH',
  dv360: 'DV360',
  xandr: 'XANDR',
  UNKNOWN: 'Unknown',
  hivestack: 'HiveStack',
  stackadapt: 'StackAdapt',
};

export const deviceMap = {
  PHONE: 'Phone',
  TABLET: 'Tablet',
  PC: 'PC',
  OTHER: 'Other',
  UNKOWN: 'Unkown',
  SMART_TV: 'Smart TV',
};

export const ignoredFilters = [
  '#N/A',
  'BUILDINGS AND STRUCTURES',
  'HEALTHCARE',
  'GOVERNMENT AND COMMUNITY',
  'BUSINESSES AND SERVICES',
  'LANDMARK',
];

export const customizeReportCheckbox = [
  {
    label: 'Overview',
    name: 'overview',
    parent: 'overview',
    children: [
      {
        label: 'Campaign Information',
        name: 'campaignInfo',
        parent: 'overview',
      },
      { label: 'Metrics', name: 'metrics', parent: 'overview' },
      { label: 'Partners Table', name: 'partnersTable', parent: 'overview' },
      { label: 'Platforms', name: 'platforms', parent: 'overview' },
    ],
  },
  {
    label: 'Reach',
    name: 'reach',
    children: [
      { label: 'Impressions & Conversion Rate', name: 'impClick&convRate' },
      { label: 'Average of the Week', name: 'avgOfWeek' },
      { label: 'Average of the Day', name: 'avgOfDay' },
      { label: 'Cohort Analysis', name: 'platforms' },
    ],
  },
];

// Seleted Report checked and expanded values

export const DEFAULT_REPORT_CHECKED_VALUE = [
  'campaignInfo',
  'metrics',
  'partnersTable',
  'platforms',
  'creative',
  'publisher',
  'deviceTypes',
  'customValue',
  'impClick',
  'avgOfWeek',
  'avgOfDay',
  'cohortAnalysis',
  'multiTouchAttribution',
  'engagDay&Time',
  'visit&AdFrequencyAnalysis',
  'gender',
  'ageGroups',
  'conversionPattern',
  'visitationPattern',
  'home',
  'work',
  'devices',
  'carriers',
  'appCategories',
  'appNames',
  'interests',
  'intents',
  'events',
  'onlineBrands',
  'financial',
  'homeType',
  'household',
  'housing',
  'currentHomeValueCodeEstimate',
  'occupation',
  'auto',
  'purchase_behaviour',
  'placesAnalysis',
  'distanceFromHome',
  'distanceFromWork',
  'leadTimeConversion',
  'dwellTime',
  'brandSegments',
  'categorySegments',
  'geoBehavioralPersonas',
  'competitionFootfallAnalysis',
  'billboardPerformance',
  'visitLiftStudy',
  'stateReachAnalysis',
  'visitLiftStudy',
  'age',
  'creativeLevelAnalysis',
  'creativeLevelAnalysis',
  'monthlyBreakdown',
];

export const DEFAULT_REPORT_EXPANDED_VALUE = [
  'overview',
  'reach',
  'audiences',
  'places',
];

// Nodes for react tree checkbox

export const customizedReportNodes = [
  {
    value: 'overview',
    label: 'Overview',
    children: [
      {
        value: 'campaignInfo',
        label: 'Campaign Information',
      },
      {
        value: 'metrics',
        label: 'Metrics',
      },
      {
        value: 'partnersTable',
        label: 'Partners Table',
      },
      {
        value: 'platforms',
        label: 'Platforms',
      },
      {
        value: 'creative',
        label: 'Creative',
      },
      {
        value: 'publisher',
        label: 'Publisher',
      },
      {
        value: 'deviceTypes',
        label: 'Device Types',
      },
      {
        value: 'customValue',
        label: 'Custom Value',
      },
    ],
  },
  {
    value: 'reach',
    label: 'Reach',
    children: [
      {
        value: 'impClick',
        label: 'Impressions & Conversion Rate',
      },
      {
        value: 'avgOfWeek',
        label: 'Average of the Week',
      },
      {
        value: 'avgOfDay',
        label: 'Average of the Day',
      },
      {
        value: 'cohortAnalysis',
        label: 'Cohort Analysis',
      },
      {
        value: 'multiTouchAttribution',
        label: 'Daily Visit Analysis',
      },
      {
        value: 'engagDay&Time',
        label: 'Reach Day & Time',
      },
      {
        value: 'visit&AdFrequencyAnalysis',
        label: 'Visit & Ad Frequency Analysis',
      },
      {
        value: 'stateReachAnalysis',
        label: 'State Reach Analysis',
      },
    ],
  },
  {
    value: 'audiences',
    label: 'Audiences',
    children: [
      {
        value: 'gender',
        label: 'Gender',
      },
      {
        value: 'ageGroups',
        label: 'Age Groups',
      },
      {
        value: 'conversionPattern',
        label: 'Conversion Pattern',
      },
      {
        value: 'visitationPattern',
        label: 'Visitation Pattern',
      },
      {
        value: 'devices',
        label: 'Devices',
      },
      {
        value: 'carriers',
        label: 'Carriers',
      },
      {
        value: 'appCategories',
        label: 'App Categories',
      },
      {
        value: 'appNames',
        label: 'App Names',
      },
      {
        value: 'interests',
        label: 'Interests',
      },
      {
        value: 'intents',
        label: 'Intents',
      },
      {
        value: 'events',
        label: 'Events',
      },
      {
        value: 'onlineBrands',
        label: 'Online Brands',
      },
    ],
  },
  {
    value: 'places',
    label: 'Places',
    children: [
      {
        value: 'placesAnalysis',
        label: 'Places Analysis',
      },
      {
        value: 'distanceFromHome',
        label: 'Distance from Home',
      },
      {
        value: 'distanceFromWork',
        label: 'Distance from Work',
      },
      {
        value: 'leadTimeConversion',
        label: 'Lead Time Conversion',
      },
      {
        value: 'dwellTime',
        label: 'Dwell Time',
      },
      {
        value: 'brandSegments',
        label: 'Brand Segments',
      },
      {
        value: 'categorySegments',
        label: 'Category Segments',
      },
      {
        value: 'geoBehavioralPersonas',
        label: 'Geo-Behavioral Personas',
      },
      {
        value: 'competitionFootfallAnalysis',
        label: 'Competition Footfall Analysis',
      },
      {
        value: 'billboardPerformance',
        label: 'Billboard Performance',
      },
    ],
  },
];

export const isShowItem = (isReportPrint, checked, item) =>
  !isReportPrint || (isReportPrint && checked.includes(item));

export function addFourDaysAndCheck(dateString) {
  try {
    const newDate = moment(dateString, 'DD/MM/YYYY HH:mm:ss').add(4, 'days');
    const currentDate = moment();
    return currentDate.isSameOrAfter(newDate);
  } catch (e) {
    return false;
  }
}

export const reshapeData = (current, item) => ({
  ...current,
  [item[0]]: +item[1].toFixed(2),
});
